






















































































































































import Vue from "vue";
import { SharedState } from "@/common/state";
import { automate_state } from "../data/automate.state";
import { ref, computed, onMounted } from "@vue/composition-api";
import { isNotEmpty, uniq } from "@/fp";
import L0Nav from "./L0Nav.vue";
import CognniLabels from "./CognniLabels.vue";
import MipLabels from "./MipLabels.vue";
import MatchCard from "./MatchCard.vue";
import { UseModal } from "@/components/root/modal";
import OveridelabelsModalVue from "../OveridelabelsModal.vue";
import ThemeImg from "@/components/ThemeImg.vue";
import { MipCognniCombination, MipBaseLabelOverride } from "../data/model";
import { common_state } from "../data/common.state";
import { LABEL_PROVIDERS } from "../data/provider";
import { put_label_override_beta, updateOverrides } from "../data/api";
import { label_api_application_of } from "../data/provider";
import MatchCardRow from "./MatchCardRow.vue";
import StatefulContainer from "@/components/StatefulContainer.vue";

export default Vue.extend({
  components: {
    L0Nav,
    CognniLabels,
    MipLabels,
    MatchCard,
    ThemeImg,
    MatchCardRow,
    StatefulContainer,
  },
  setup(_, { root: { $router } }) {
    const { l0InfoTypes } = SharedState;
    const {
      init,
      state,
      is_loading,
      delete_combination,
      add_combination,
      change_threshold_for_ui,
    } = automate_state;
    const selected_l0_id = ref(l0InfoTypes.value[0].id);
    const change_l0 = (l0_id: string) => {
      selected_l0_id.value = l0_id;
      clear_selections();
    };

    const current_l0_name = computed(() => {
      if (selected_l0_id.value) {
        return SharedState.getInfoType(selected_l0_id.value).labelName;
      }
      return "";
    });

    const selected_cognni_label_id = ref("");
    const selected_mip_label_id = ref("");

    const clear_selections = () => {
      selected_cognni_label_id.value = "";
      selected_mip_label_id.value = "";
    };

    const did_user_created_a_match = computed(
      () =>
        isNotEmpty(selected_cognni_label_id.value) &&
        isNotEmpty(selected_mip_label_id.value)
    );

    const selected_L0_code = computed(
      () => SharedState.allInfoTypes.value[selected_l0_id.value].code
    );

    const combinations = computed(() =>
      state.combinations
        .filter(({ labelId }) => {
          const {
            code,
            content_code,
            infoTypeCategoryId,
          } = SharedState.getInfoType(labelId);
          return (
            [code, content_code].includes(selected_L0_code.value) ||
            infoTypeCategoryId == selected_l0_id.value
          );
        })
        .map((l) => {
          const label_config = common_state.state.labels_config[l.labelId];
          return {
            ...l,
            override: label_config ? label_config.override : false,
          };
        })
    );

    const get_mip_label_name = (id: string) => {
      return common_state.state.indexed_mip_labels[id].labelName;
    };

    const open_override_modal = async (payload: {
      label_id: string;
      mip_label_id: string;
      label_name: string;
      label_code: number;
    }) => {
      const mip_label_name: string = get_mip_label_name(payload.mip_label_id);
      payload.label_name = payload.label_name + " > " + mip_label_name;
      // the mapped label itself is never its own override
      const not_mapped_label = (mip_label_id: string) =>
        mip_label_id !== payload.mip_label_id;
      const legacy_apply = async (override: boolean, ids: string[]) => {
        const overrides = ids.filter(not_mapped_label);
        if (!overrides.length) return;
        await updateOverrides(
          overrides.map((id) => ({
            externalLabelId: id,
            labelId: payload.label_id,
            override,
          }))
        );
      };
      const res = await UseModal().show(OveridelabelsModalVue, {
        ...payload,
        /**
         * The overrides as the modal leaves them, written once: label-api's
         * beta override takes the whole picture (task 25038). A provider
         * without it writes the toggle and the changes through
         * integrations-manager, as before.
         */
        save: async (o: {
          full: boolean;
          full_changed: boolean;
          yes: string[];
          no: string[];
          newly_checked: string[];
          newly_unchecked: string[];
        }) => {
          const application = label_api_application_of(common_state.state.provider);
          if (application) {
            const saved = await put_label_override_beta({
              labelId: payload.label_id,
              application,
              full: o.full,
              yes: o.yes.filter(not_mapped_label),
              no: o.no.filter(not_mapped_label),
            });
            if (saved.success) {
              common_state.mutate_override_all_status(payload.label_id, o.full);
            }
            return;
          }
          if (o.full_changed) {
            await common_state.update_override_all_status_for_label(payload.label_id, o.full);
            await legacy_apply(true, o.yes);
            if (!o.full) await legacy_apply(false, o.no);
            return;
          }
          await legacy_apply(true, o.newly_checked);
          await legacy_apply(false, o.newly_unchecked);
        },
      });

      if (res.type === "success") {
        // @ts-ignore
        const overrides_arr = (res.msg as string[]).filter(
          (l) => l !== payload.mip_label_id
        );
        automate_state.update_combination_overrides(
          payload.label_id,
          overrides_arr
        );
      }
    };

    const unlink_combination = async (item: MipCognniCombination) => {
      const { label_name, external_label_name } = item.runtime;
      const res = await UseModal().showSimple({
        title: "Unlink Labels",
        desc: `Sure you want to remove the link between <br><b>${label_name}</b> & <span class="text-dark"><b>${external_label_name}</b></span>?`,
        submitBtnText: "yes",
        cancelBtnText: "no",
      });
      if (res.type === "success") {
        await delete_combination(item.labelId);
      }
    };

    const link_labels = async () => {
      const cognni_label = SharedState.getInfoType(
        selected_cognni_label_id.value
      );
      const mip_label =
        common_state.state.indexed_mip_labels[selected_mip_label_id.value];

      const existing_mappings = state.combinations
        .filter(
          (l) =>
            l.externalLabelId === mip_label.labelId &&
            SharedState.getInfoType(l.labelId).parentId !== selected_l0_id.value
        )
        .map((l) => {
          const label = SharedState.getInfoType(
            SharedState.getInfoType(l.labelId).parentId as string
          );
          return label.labelName;
        });
      console.log("existing_mappings : ", existing_mappings);
      if (existing_mappings.length > 0) {
        const l0s_names = uniq(existing_mappings)
          .map((l) => `<b>${l}</b>`)
          .join(" ,");
        const res = await UseModal().showSimple({
          title: "Label Consistency Alert",
          desc: `${mip_label.labelName} is already linked to: ${l0s_names}.<br>
          Do you wish to proceed?
          `,
          submitBtnText: "Yes",
          cancelBtnText: "No",
        });
        if (res.type === "success") {
          await add_combination(cognni_label, mip_label);
          reset_selected_labels();
        }
      } else {
        await add_combination(cognni_label, mip_label);
        reset_selected_labels();
      }
    };

    const reset_selected_labels = () => {
      selected_cognni_label_id.value = "";
      selected_mip_label_id.value = "";
    };

    const change_threshold_just_locally_for_ui = (payload: {
      id: string;
      value: number;
    }) => {
      change_threshold_for_ui(payload.id, payload.value);
    };

    const change_threshold = async (payload: {
      id: string;
      value: number;
      done: Function;
    }) => {
      await automate_state.change_threshold(payload.id, payload.value);
      payload.done();
    };

    const display_configure = ref(false);
    const override_desc = `<p>Configuring your "Override" settings prioritizes whether a file <b> with an existing MIP sensitivity label</b> will receive a new label through Cognni's automation.</p> <br/><p> Choosing a sensitivity label and selecting other sensitivity labels to override will determine whether to <b>keep or change</b> the sensitivity label on those file in the event of conflicting classifications</p>`;

    const confidence_desc = `<div><p>The value of this field will establish a <b>minimum</b> confidence level at
          which MIP sensitivity labels will be applied.<br/><br/>
          Cognni confidence levels can be found by:</p>
           <ul class="pl-5">
          <li class="list-disc">Entering file views in the platform</li>
          <li class="list-disc">Clicking on the file's category or subcategory
          </ul>
          </div>`;

    onMounted(async () => {
      common_state.on_ready(async () => {
        const { type, tab } = $router.currentRoute.query;
        if (type) {
          selected_l0_id.value = type as string;
        }
        if (tab && tab === "configure") {
          display_configure.value = true;
        }
        await init();
      });
    });

    // every provider-specific string on this page comes from here
    const provider_config = computed(
      () => LABEL_PROVIDERS[common_state.state.provider]
    );

    return {
      provider_config,
      selected_l0_id,
      change_l0,
      did_user_created_a_match,
      selected_cognni_label_id,
      selected_mip_label_id,
      clear_selections,
      combinations,
      is_loading,
      open_override_modal,
      current_l0_name,
      unlink_combination,
      link_labels,
      change_threshold_just_locally_for_ui,
      change_threshold,
      display_configure,
      override_desc,
      confidence_desc,
    };
  },
});
